module.exports = __webpack_public_path__ + "static/media/mars.6a056191.png";